var React = require('react');

function IconProject (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 9V4.997h-7A5 5 0 0 1 10 4l-1.2-.9A5.503 5.503 0 0 0 5.5 2H2v18h18V9zM1.5 0h4C7.124 0 8.703.526 10 1.499l1.2.9a3 3 0 0 0 1.8.598h7.5a1.5 1.5 0 0 1 1.5 1.5V20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V1.5A1.5 1.5 0 0 1 1.5 0zm12.141 15.574l2.297-2.538-2.297-2.539a.9.9 0 0 1 .05-1.255.86.86 0 0 1 1.233.052l2.841 3.14a.9.9 0 0 1 0 1.204l-2.841 3.14a.86.86 0 0 1-1.232.05.9.9 0 0 1-.05-1.254zm-5.26-5.077l-2.297 2.539 2.297 2.538a.9.9 0 0 1-.05 1.255.86.86 0 0 1-1.232-.051l-2.842-3.14a.9.9 0 0 1 0-1.204L7.1 9.294a.86.86 0 0 1 1.232-.052.9.9 0 0 1 .05 1.255zm2.62 4.283c-.963 0-1.743-.795-1.743-1.776s.78-1.776 1.743-1.776c.963 0 1.744.795 1.744 1.776s-.78 1.776-1.744 1.776z","fill":"currentColor","fillRule":"nonzero"}));
}

IconProject.defaultProps = {"width":"22","height":"22"};

module.exports = IconProject;

IconProject.default = IconProject;
